import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './fonts-critical.css';
import './theme.css';
import './index.css';
import App from './App.tsx';

/* Preload критичных WOFF2 — в production вставляются в index.html (vite.config injectEarlyFontPreloads). */

console.log('🚀 Инициализация приложения...');

/* Дублирует inline-скрипт в index.html — на случай если модуль грузится без prerender-обёртки */
document.getElementById('seo-static-fallback')?.remove();

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('❌ Root element не найден!');
  throw new Error('Root element not found');
}

console.log('✅ Root element найден, рендеринг приложения...');

try {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
  console.log('✅ Приложение успешно отрендерено');
} catch (error) {
  console.error('❌ Ошибка при рендеринге:', error);
  throw error;
}
